// Generated by `php artisan tracking:generate` from app/Tracking/UserEvent.php. Do not edit.

/** Identifier-valued properties must match this: lower-case words joined by -, _ or :. */
export const IDENTIFIER_PATTERN = /^[a-z0-9]+(?:[-_:][a-z0-9]+)*$/;

export const USER_EVENTS = {
  'artwork.composer_opened': {
    side: 'client',
    fathom: null,
    subjects: [],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      trigger: { type: 'string', required: true, values: ['prompt', 'settings'] },
    },
  },
  'artwork.failed_prompt_reopened': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      kind: { type: 'string', required: true, values: ['generate', 'edit'] },
      surface: { type: 'string', required: true, values: ['tile', 'details'] },
      attempt: { type: 'int', required: true, min: 1 },
    },
  },
  'artwork.featured_removed': {
    side: 'client',
    fathom: null,
    subjects: [],
    properties: {
      origin: { type: 'string', required: true, values: ['typed', 'agent'] },
      surface: { type: 'string', required: true, values: ['composer', 'edit'] },
    },
  },
  'artwork.hint_clicked': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      hint: { type: 'string', required: true, maxLength: 40 },
    },
  },
  'artwork.hint_shown': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      hint: { type: 'string', required: true, maxLength: 40 },
    },
  },
  'artwork.prompt_assistant_used': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      kind: { type: 'string', required: true, values: ['idea_picked', 'rewrite'] },
      surface: { type: 'string', required: true, values: ['composer', 'edit'] },
      ideas: { type: 'int', required: false, min: 0 },
      typed: { type: 'bool', required: false },
    },
  },
  'artwork.tile_action_used': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      action: { type: 'string', required: true, values: ['primary', 'edit', 'reference', 'download', 'delete'] },
      surface: { type: 'string', required: false, values: ['tile', 'viewer'] },
      format: { type: 'string', required: false, values: ['webp', 'png', 'jpeg'] },
    },
  },
  'artwork.tool_used': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      tool: { type: 'string', required: true, values: ['surprise', 'lucky-dip', 'edit'] },
    },
  },
  'artwork.viewer_details_opened': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
    },
  },
  'artwork.viewer_opened': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      via: { type: 'string', required: true, values: ['image', 'edit'] },
    },
  },
  'assistant.change_jumped': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
    },
  },
  'assistant.op_skipped': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      reason: { type: 'string', required: true, values: ['block_changed', 'block_gone', 'place_gone', 'invalid', 'no_editor'] },
    },
  },
  'assistant.panel_opened': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      surface: { type: 'string', required: true, values: ['toolbar', 'shortcut', 'insert_menu', 'full_screen', 'keyboard_bar', 'phone_bar'] },
    },
  },
  'assistant.stopped': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      ops: { type: 'int', required: true, min: 0 },
    },
  },
  'assistant.undo': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      ops: { type: 'int', required: true, min: 0 },
    },
  },
  'character_card.viewed': {
    side: 'client',
    fathom: null,
    subjects: ['character'],
    properties: {
      surface: { type: 'string', required: true, values: ['tab', 'actions_sheet', 'hint'] },
      fit: { type: 'string', required: true, values: ['full', 'reduced', 'over'] },
    },
  },
  'codex.dice_rolled': {
    side: 'fathom_only',
    fathom: 'codex:dice.rolled',
    subjects: [],
    properties: {
    },
  },
  'credits.depleted': {
    side: 'fathom_only',
    fathom: 'credits:depleted',
    subjects: [],
    properties: {
    },
  },
  'credits.viewed': {
    side: 'fathom_only',
    fathom: 'credits:viewed',
    subjects: [],
    properties: {
    },
  },
  'dashboard.tutorial_clicked': {
    side: 'client',
    fathom: null,
    subjects: [],
    properties: {
      slug: { type: 'string', required: true, maxLength: 100 },
    },
  },
  'dm_only.toggled': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      to: { type: 'string', required: true, values: ['revealed', 'hidden'] },
    },
  },
  'editor.ai_used': {
    side: 'client',
    fathom: null,
    subjects: [],
    properties: {
      action: { type: 'string', required: true, values: ['command', 'inline_action', 'accepted', 'rejected', 'quick_action'] },
    },
  },
  'editor.command_menu_opened': {
    side: 'client',
    fathom: null,
    subjects: [],
    properties: {
      via: { type: 'string', required: true, values: ['button', 'slash'] },
    },
  },
  'editor.focus_mode_entered': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
    },
  },
  'entity.creation_mode_chosen': {
    side: 'client',
    fathom: null,
    subjects: [],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      mode: { type: 'string', required: true, values: ['manual', 'wizard', 'steering', 'upload'] },
      card: { type: 'string', required: true, maxLength: 40 },
    },
  },
  'generator.cta_clicked': {
    side: 'fathom_only',
    fathom: 'generator:cta.clicked',
    subjects: [],
    properties: {
    },
  },
  'generator.name_clicked': {
    side: 'fathom_only',
    fathom: 'generator:name.clicked',
    subjects: [],
    properties: {
    },
  },
  'generator.name_generated': {
    side: 'fathom_only',
    fathom: 'generator:name.generated',
    subjects: [],
    properties: {
    },
  },
  'generator.name_signup_started': {
    side: 'fathom_only',
    fathom: 'generator:name.signup_started',
    subjects: [],
    properties: {
    },
  },
  'item_card.viewed': {
    side: 'client',
    fathom: null,
    subjects: ['item'],
    properties: {
      surface: { type: 'string', required: true, values: ['tab', 'actions_sheet', 'hint', 'fit_bar'] },
      fit: { type: 'string', required: true, values: ['full', 'reduced', 'over'] },
    },
  },
  'map.opened': {
    side: 'client',
    fathom: null,
    subjects: ['location'],
    properties: {
      surface: { type: 'string', required: true, values: ['studio', 'maps_page', 'drill_down', 'direct'] },
    },
  },
  'miniature.downloaded': {
    side: 'client',
    fathom: null,
    subjects: ['character'],
    properties: {
      format: { type: 'string', required: true, values: ['glb', 'stl'] },
      surface: { type: 'string', required: false, values: ['miniature_card', 'media_library', 'model_viewer'] },
    },
  },
  'miniature.url_copied': {
    side: 'client',
    fathom: null,
    subjects: ['character'],
    properties: {
      format: { type: 'string', required: true, values: ['glb', 'stl'] },
    },
  },
  'print_tab.print_chosen': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity_type: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      from: { type: 'string', required: true, values: ['card', 'sheet', 'stat-block', 'codex'] },
      to: { type: 'string', required: true, values: ['card', 'sheet', 'stat-block', 'codex'] },
    },
  },
  'print_tab.viewed': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity_type: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      print: { type: 'string', required: true, values: ['card', 'sheet', 'stat-block', 'codex'] },
      prints: { type: 'int', required: true, min: 1 },
    },
  },
  'purchase.cancelled': {
    side: 'fathom_only',
    fathom: 'purchase:cancelled',
    subjects: [],
    properties: {
    },
  },
  'purchase.completed': {
    side: 'fathom_only',
    fathom: 'purchase:completed',
    subjects: [],
    properties: {
      value_cents: { type: 'int', required: true, min: 0 },
    },
  },
  'purchase.initiated': {
    side: 'fathom_only',
    fathom: 'purchase:initiated',
    subjects: [],
    properties: {
      value_cents: { type: 'int', required: true, min: 0 },
    },
  },
  'quick_roll.rolled': {
    side: 'client',
    fathom: null,
    subjects: [],
    properties: {
      type: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'encounter', 'shop'] },
    },
  },
  'quick_roll.type_changed': {
    side: 'client',
    fathom: null,
    subjects: [],
    properties: {
      type: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'encounter', 'shop'] },
    },
  },
  'quick_roll.used': {
    side: 'client',
    fathom: null,
    subjects: [],
    properties: {
      type: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'encounter', 'shop'] },
      via: { type: 'string', required: false, values: ['tile', 'button'] },
    },
  },
  'settings.section_viewed': {
    side: 'client',
    fathom: null,
    subjects: [],
    properties: {
      section: { type: 'string', required: true, values: ['profile', 'security', 'apps', 'appearance', 'printing', 'tips', 'email', 'delete'] },
    },
  },
  'showcase.create_cta_clicked': {
    side: 'fathom_only',
    fathom: 'showcase:cta.create',
    subjects: [],
    properties: {
    },
  },
  'steering.rolled': {
    side: 'client',
    fathom: null,
    subjects: [],
    properties: {
      kind: { type: 'string', required: true, values: ['character', 'npc', 'item', 'monster', 'location', 'faction', 'encounter', 'quest', 'session', 'trap', 'puzzle', 'shop'] },
    },
  },
  'studio.artwork_link_clicked': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction'],
    properties: {
    },
  },
  'user.registered': {
    side: 'fathom_only',
    fathom: 'user:registered',
    subjects: [],
    properties: {
    },
  },
} as const;

export type UserEventName = keyof typeof USER_EVENTS;

/** What each event must be called with. The compiler refuses a missing, unknown or out-of-range property. */
export interface UserEventPayloads {
  'artwork.composer_opened': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; trigger: 'prompt' | 'settings' };
  'artwork.failed_prompt_reopened': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; kind: 'generate' | 'edit'; surface: 'tile' | 'details'; attempt: number };
  'artwork.featured_removed': { origin: 'typed' | 'agent'; surface: 'composer' | 'edit' };
  'artwork.hint_clicked': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; hint: string };
  'artwork.hint_shown': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; hint: string };
  'artwork.prompt_assistant_used': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; kind: 'idea_picked' | 'rewrite'; surface: 'composer' | 'edit'; ideas?: number; typed?: boolean };
  'artwork.tile_action_used': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; action: 'primary' | 'edit' | 'reference' | 'download' | 'delete'; surface?: 'tile' | 'viewer'; format?: 'webp' | 'png' | 'jpeg' };
  'artwork.tool_used': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; tool: 'surprise' | 'lucky-dip' | 'edit' };
  'artwork.viewer_details_opened': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document' };
  'artwork.viewer_opened': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; via: 'image' | 'edit' };
  'assistant.change_jumped': Record<string, never>;
  'assistant.op_skipped': { reason: 'block_changed' | 'block_gone' | 'place_gone' | 'invalid' | 'no_editor' };
  'assistant.panel_opened': { surface: 'toolbar' | 'shortcut' | 'insert_menu' | 'full_screen' | 'keyboard_bar' | 'phone_bar' };
  'assistant.stopped': { ops: number };
  'assistant.undo': { ops: number };
  'character_card.viewed': { surface: 'tab' | 'actions_sheet' | 'hint'; fit: 'full' | 'reduced' | 'over' };
  'codex.dice_rolled': Record<string, never>;
  'credits.depleted': Record<string, never>;
  'credits.viewed': Record<string, never>;
  'dashboard.tutorial_clicked': { slug: string };
  'dm_only.toggled': { to: 'revealed' | 'hidden' };
  'editor.ai_used': { action: 'command' | 'inline_action' | 'accepted' | 'rejected' | 'quick_action' };
  'editor.command_menu_opened': { via: 'button' | 'slash' };
  'editor.focus_mode_entered': Record<string, never>;
  'entity.creation_mode_chosen': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; mode: 'manual' | 'wizard' | 'steering' | 'upload'; card: string };
  'generator.cta_clicked': Record<string, never>;
  'generator.name_clicked': Record<string, never>;
  'generator.name_generated': Record<string, never>;
  'generator.name_signup_started': Record<string, never>;
  'item_card.viewed': { surface: 'tab' | 'actions_sheet' | 'hint' | 'fit_bar'; fit: 'full' | 'reduced' | 'over' };
  'map.opened': { surface: 'studio' | 'maps_page' | 'drill_down' | 'direct' };
  'miniature.downloaded': { format: 'glb' | 'stl'; surface?: 'miniature_card' | 'media_library' | 'model_viewer' };
  'miniature.url_copied': { format: 'glb' | 'stl' };
  'print_tab.print_chosen': { entity_type: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; from: 'card' | 'sheet' | 'stat-block' | 'codex'; to: 'card' | 'sheet' | 'stat-block' | 'codex' };
  'print_tab.viewed': { entity_type: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; print: 'card' | 'sheet' | 'stat-block' | 'codex'; prints: number };
  'purchase.cancelled': Record<string, never>;
  'purchase.completed': { value_cents: number };
  'purchase.initiated': { value_cents: number };
  'quick_roll.rolled': { type: 'character' | 'npc' | 'monster' | 'item' | 'encounter' | 'shop' };
  'quick_roll.type_changed': { type: 'character' | 'npc' | 'monster' | 'item' | 'encounter' | 'shop' };
  'quick_roll.used': { type: 'character' | 'npc' | 'monster' | 'item' | 'encounter' | 'shop'; via?: 'tile' | 'button' };
  'settings.section_viewed': { section: 'profile' | 'security' | 'apps' | 'appearance' | 'printing' | 'tips' | 'email' | 'delete' };
  'showcase.create_cta_clicked': Record<string, never>;
  'steering.rolled': { kind: 'character' | 'npc' | 'item' | 'monster' | 'location' | 'faction' | 'encounter' | 'quest' | 'session' | 'trap' | 'puzzle' | 'shop' };
  'studio.artwork_link_clicked': Record<string, never>;
  'user.registered': Record<string, never>;
}
